import { i18n } from "src/boot/i18n"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { BreadcrumbText } from "src/util/types/components/sfxBreadcrumb"

export async function getWorkspaceHomeBreadcrumb(): Promise<BreadcrumbText> {
  const { useAuthStore } = await import("src/stores/authStore")
  const authStore = useAuthStore()
  const { t } = i18n.global

  return {
    text: authStore.selectedWorkspace?.name || t("items.workspace_name"),
    link: {
      name: NamedManagerPath.WORKSPACE,
      params: { workspaceId: authStore.selectedWorkspace?.id },
    },
    highlight: true,
  }
}
